import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAllCreatorSessions } from "../../redux/actions/mindfulness";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

// Styled Components
const Container = styled.div`
  max-width: 80%;
  margin: 20px auto;
  padding: 20px;
  margin-top: 100px;
  font-family: Montserrat;
`;

const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  padding: 12px 24px;
  background-color: ${(props) => (props.active ? "#ed1e24" : "#f5f5f5")};
  color: ${(props) => (props.active ? "white" : "#333")};
  border: none;
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.active ? "#ed1e24" : "#e0e0e0")};
  }
`;

const SessionCard = styled.div`
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const SessionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const SessionCreator = styled.p`
  margin: 4px 0;
  color: #333;
  font-weight: 500;
  font-size: 0.875rem;
  text-transform: capitalize;
`;
const SessionTitle = styled.h3`
  margin: 0;
  color: #333;
  font-size: 18px;
`;

const SessionCategory = styled.span`
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
`;

const SessionInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const InfoColumn = styled.div`
  display: flex;
  /* flex-direction: column; */
  gap: 5px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
`;

const Icon = styled.span`
  font-size: 14px;
`;

const Description = styled.p`
  margin: 15px 0;
  line-height: 1.5;
  color: #444;
`;

const Objective = styled.div`
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
  margin: 15px 0;
  font-size: 14px;
  color: #555;
`;

const Settings = styled.div`
  display: flex;
  gap: 15px;
  margin: 15px 0;
  font-size: 14px;
  color: #666;
`;

const PriceSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
`;

const Price = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #333;
`;

const Duration = styled.div`
  font-size: 14px;
  color: #666;
`;

const BookButton = styled.button`
  width: 10%;
  padding: 12px;
  background-color: #ff3b30;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: background-color 0.3s ease;
  margin-left: 90%;

  &:hover {
    background-color: #e6342a;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  ${(props) =>
    props.status === "live" &&
    `
    background-color: #4CAF50;
    color: white;
  `}
  ${(props) =>
    props.status === "inactive" &&
    `
    background-color: #FF9800;
    color: white;
  `}
`;

const Heading = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  background: #ed1e24;
  color: #fff;
  padding: 0.5rem 1.5rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  width: fit-content;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ProfileImage = styled.div`
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 15px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LoaderWrapper = styled.div`
  margin-top: 25%;
  text-align: center;
`;

const AllSessions = () => {
  //   const sessions = [
  //     {
  //       name: "Morning Gratitude Meditation",
  //       category: "Meditation",
  //       duration: 45,
  //       description:
  //         "Start your day with gratitude-focused meditation to cultivate positivity and intention.",
  //       conversation_type_amount: {
  //         call: 100,
  //         chat: 100,
  //         video_call: 100,
  //       },
  //       objective: "Build daily gratitude practice and set positive intentions",
  //       setting_config: {
  //         level: "Beginner",
  //         language: "English",
  //       },
  //       is_live: true,
  //       max_booking_per_day: 15,
  //       is_active: true,
  //       timestamp: "2026-01-09T06:30:00.000000Z",
  //       utimestamp: "2026-01-09T06:30:00.000000Z",
  //     },
  //     {
  //       name: "Deep Sleep Preparation Session",
  //       category: "Meditation",
  //       duration: 30,
  //       description:
  //         "Wind down with guided meditation designed specifically for better sleep quality.",
  //       conversation_type_amount: {
  //         call: 80,
  //         chat: 120,
  //         video_call: 50,
  //       },
  //       objective:
  //         "Promote deep relaxation and prepare the mind for restorative sleep",
  //       setting_config: {
  //         level: "Intermediate",
  //         language: "English",
  //       },
  //       is_live: false,
  //       max_booking_per_day: 20,
  //       is_active: true,
  //       timestamp: "2026-01-09T10:15:45.123456Z",
  //       utimestamp: "2026-01-09T10:15:45.123489Z",
  //     },
  //     {
  //       name: "Loving-Kindness Practice",
  //       category: "Meditation",
  //       duration: 50,
  //       description:
  //         "Metta meditation to cultivate compassion for self and others.",
  //       conversation_type_amount: {
  //         call: 90,
  //         chat: 90,
  //         video_call: 110,
  //       },
  //       objective:
  //         "Develop unconditional love and compassion through metta practice",
  //       setting_config: {
  //         level: "Beginner",
  //         language: "English",
  //       },
  //       is_live: true,
  //       max_booking_per_day: 12,
  //       is_active: true,
  //       timestamp: "2026-01-09T11:45:22.567890Z",
  //       utimestamp: "2026-01-09T11:45:22.567923Z",
  //     },
  //   ];
  const [isLoading, setIsLoading] = useState(true);

  const sessionData =
    useSelector((state) => state?.mindfulness?.creatorSessions) || [];

  const dispatch = useDispatch();

  const [sessions, setSessions] = useState(sessionData);

  // Format date to display time
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  useEffect(async () => {
    await dispatch(getAllCreatorSessions());
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setSessions(sessionData);
  }, [sessionData]);

  console.log("session data", sessionData);

  if (isLoading) {
    return (
      <LoaderWrapper>
        <CircularProgress sx={{ color: "#ED1E24" }} size={50} />
      </LoaderWrapper>
    );
  }

  return (
    <Container>
      <Heading>All Sessions</Heading>
      {/* <TabContainer>
        <Tab active={true}>All Sessions</Tab>
        <Tab>Upcoming</Tab>
        <Tab>Past</Tab>
      </TabContainer> */}

      {sessions.map((session, index) => (
        <SessionCard key={index}>
          <SessionHeader>
            <div>
              <SessionTitle>{session.name}</SessionTitle>
              <SessionCreator>{session.creator_name}</SessionCreator>
              <SessionCategory>{session.category}</SessionCategory>
            </div>
            {/* <StatusBadge status={session.is_live ? 'live' : 'inactive'}>
              {session.is_live ? 'Live' : 'Not Live'}
            </StatusBadge> */}
          </SessionHeader>

          <SessionInfo>
            <InfoColumn>
              <InfoItem>
                <Icon>🕒</Icon>
                {formatDate(session.timestamp)}
              </InfoItem>
              <InfoItem>
                <Icon>⏱️</Icon>
                {session.duration} min
              </InfoItem>
            </InfoColumn>
          </SessionInfo>

          <Description>{session.description}</Description>

          <Objective>
            <strong>Objective:</strong> {session.objective}
          </Objective>

          {Object.values(session.conversation_type_amount).length > 0 ? (
            <PriceSection>
              <Price>
                ₹{Object.values(session.conversation_type_amount)?.[0]}
              </Price>
            </PriceSection>
          ) : null}

          <BookButton>Book Session</BookButton>
        </SessionCard>
      ))}
    </Container>
  );
};

export default AllSessions;
